import { render, staticRenderFns } from "./EditContractPartner.vue?vue&type=template&id=c10c9a62&scoped=true"
import script from "./EditContractPartner.vue?vue&type=script&lang=js"
export * from "./EditContractPartner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c10c9a62",
  null
  
)

export default component.exports